import { UserRole } from '@synergy/models';
import { hasRole } from '@synergy/utils';

import { User } from '../models/user';

export const isSupplier = (user: User): boolean =>
    hasRole([UserRole.SupplierAdmin, UserRole.Extranet], user) &&
    !hasRole([UserRole.ShopAdmin, UserRole.ShopUser], user);
